// 环境配置
export const ENV_CONFIG = {
  // 检查是否为开发环境
  isDevelopment: import.meta.env.MODE === 'development',
  
  // API配置
  API: {
    // 原始API地址
    ORIGINAL_URL: 'https://app.startvpn.xyz/api/sub/queryAppleAccounts',
    // 代理API地址
    PROXY_URL: '/api-proxy',
    // 根据环境返回对应的API地址
    getUrl: () => ENV_CONFIG.isDevelopment ? ENV_CONFIG.API.ORIGINAL_URL : ENV_CONFIG.API.PROXY_URL
  },
  
  // 请求配置
  REQUEST: {
    // 获取请求头
    getHeaders: () => ({
      'Content-Type': 'application/json',
      ...(ENV_CONFIG.isDevelopment ? { 'decrypt': '1' } : {})
    }),
    
    // 获取请求选项
    getOptions: () => ({
      method: 'POST',
      headers: ENV_CONFIG.REQUEST.getHeaders(),
      ...(ENV_CONFIG.isDevelopment ? {} : { body: JSON.stringify({}) })
    })
  }
}

// 调试信息
if (ENV_CONFIG.isDevelopment) {
  console.log('🔧 开发环境已启用')
  console.log('📡 API地址:', ENV_CONFIG.API.getUrl())
} else {
  console.log('🚀 生产环境已启用')
  console.log('🔀 使用代理:', ENV_CONFIG.API.getUrl())
}
